import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { MotionValue, m } from 'framer-motion';

type MyCoinBadgeProps = {
    mountTo: Element;
    zIndex?: number;
    offsetY?: number;
    y?: MotionValue<number>;
}

const MyCoinBadge = ({ mountTo, zIndex = 102, offsetY = 0, y }: MyCoinBadgeProps) => {
    const [coin, setCoin] = useState(0);
    const coinListener = useRef<any>(null);

    useEffect(() => {
        setCoin(MyDataManager.getCoin());
        coinListener.current = MyDataManager.events.on('coinChanged', (newCoin: number) => {
            setCoin(newCoin);
        });

        return () => {
            if(coinListener.current) {
                coinListener.current.remove();
            }
            coinListener.current = null;
        };
    }, []);

    const content = (
      <m.div
        data-component="CoinBadge"
        className="fixed flex flex-row items-center justify-center gap-1 px-4 py-2 rounded-full"
        style={{ zIndex, top: `calc(${offsetY}px + 1rem)`, y, left: '1rem', backgroundColor: '#10101C' }}
      >
        <img src={bassets.linkle.img_webp.coin.ic_coin.webp} alt="coin" className="h-4 w-4" />
        <div className="typography-body-sm text-base-txt-secondary">{coin}</div>
      </m.div>
    );

    return createPortal(content, mountTo);
};

export default MyCoinBadge;